var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useProfileContext } from '@marketing/profile/ProfileContext';
import PetAgeInput from '@marketing/profile/common/PetAgeInput';
import { ProfileFormLayout, ProfileFormMain } from '@marketing/profile/common/ProfileFormLayout';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { convertAgeBirthdayYearMonths, determineIsLikelyPuppy } from '@utils/date_utils';
var determineAgeRelatedPetProperties = function (ageMonth, ageYear) {
    var _a = convertAgeBirthdayYearMonths(ageMonth, ageYear), birthdayMonth = _a[0], birthdayYear = _a[1];
    if (birthdayMonth === 0) {
        birthdayMonth = 12;
        birthdayYear--;
    }
    var isLikelyPuppy = determineIsLikelyPuppy(birthdayYear, birthdayMonth, ageYear, ageMonth);
    return {
        birthdayYear: birthdayYear,
        birthdayMonth: birthdayMonth,
        isLikelyPuppy: isLikelyPuppy,
    };
};
var PetAgeForm = function () {
    var navigate = useNavigate();
    var _a = useProfileContext(), currentPet = _a.currentPet, updateCurrentPet = _a.updateCurrentPet, savePetAndProfile = _a.savePetAndProfile, profileBasePath = _a.profileBasePath, sendFunnelGTMEvent = _a.sendFunnelGTMEvent;
    var _b = convertAgeBirthdayYearMonths(currentPet.birthdayMonth, currentPet.birthdayYear), month = _b[0], year = _b[1];
    var _c = useState(month || null), ageMonth = _c[0], setAgeMonth = _c[1];
    var _d = useState(year || null), ageYear = _d[0], setAgeYear = _d[1];
    var _e = useState(true), isValid = _e[0], setIsValid = _e[1];
    useEffect(function () {
        var bothFieldsValid = validateAgeMonth(ageMonth).isValid && validateAgeYear(ageYear).isValid;
        if (bothFieldsValid) {
            var _a = determineAgeRelatedPetProperties(ageMonth, ageYear), birthdayYear = _a.birthdayYear, birthdayMonth = _a.birthdayMonth, isLikelyPuppy = _a.isLikelyPuppy;
            updateCurrentPet({
                birthdayYear: birthdayYear,
                birthdayMonth: birthdayMonth,
                isPuppy: isLikelyPuppy,
            });
        }
        setIsValid(bothFieldsValid);
    }, [ageMonth, ageYear]);
    var handleClickPrevious = function () {
        navigate("".concat(profileBasePath, "/pet/age"), { viewTransition: true });
    };
    var handleAgeMonthChange = function (value) {
        setAgeMonth(value);
    };
    var handleAgeYearChange = function (value) {
        setAgeYear(value);
    };
    var validateAgeMonth = function (value) {
        var isValid = value >= 0 && value <= 11;
        var result = isValid
            ? {
                isValid: true,
                error: '',
            }
            : {
                isValid: false,
                error: 'Please enter 0-11 months',
            };
        setIsValid(isValid);
        return result;
    };
    var validateAgeYear = function (value) {
        var isValid = value >= 0 && value <= 21;
        var result = isValid
            ? {
                isValid: true,
                error: '',
            }
            : {
                isValid: false,
                error: 'Please enter 0-21 years',
            };
        setIsValid(isValid);
        return result;
    };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, birthdayYear, birthdayMonth, isLikelyPuppy, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    e.preventDefault();
                    if (!isValid) return [3 /*break*/, 4];
                    _a = determineAgeRelatedPetProperties(ageMonth, ageYear), birthdayYear = _a.birthdayYear, birthdayMonth = _a.birthdayMonth, isLikelyPuppy = _a.isLikelyPuppy;
                    updateCurrentPet({
                        birthdayYear: birthdayYear,
                        birthdayMonth: birthdayMonth,
                        isPuppy: isLikelyPuppy,
                    });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, savePetAndProfile()];
                case 2:
                    _b.sent();
                    sendFunnelGTMEvent('click-next_age');
                    navigate("".concat(profileBasePath, "/pet/weight"), { viewTransition: true });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    console.error('Error saving profile:', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var formId = 'pet-age-form';
    return (_jsx(ProfileFormLayout, __assign({ disableNext: !isValid, formId: formId, handleClickPrevious: handleClickPrevious }, { children: _jsx(ProfileFormMain, __assign({ h1: "Nom Nom Sign Up: Your Dog\u2019s Age" }, { children: _jsx("form", __assign({ id: formId, onSubmit: handleSubmit }, { children: _jsx(PetAgeInput, { ageMonth: ageMonth, ageYear: ageYear, handleAgeMonthChange: handleAgeMonthChange, handleAgeYearChange: handleAgeYearChange, petName: currentPet.name, validateAgeMonth: validateAgeMonth, validateAgeYear: validateAgeYear }) })) })) })));
};
export default PetAgeForm;
